import angular from 'angular';

FocusDirective.$inject = ['$timeout'];

function FocusDirective($timeout) {
  return {
    restrict: 'A',
    link: function ($scope, $element) {
      $timeout(function () {
        $element[0].focus();
      });
    },
  };
}

export const FocusDirectiveModule = angular
  .module('acme.common.directive.focus', [])

  .directive('acmeFocus', FocusDirective).name;
